<template>
  <div class="side-box" :class="{ active: opened.length > 0 }">
    <span class="side-box__overlay" />
    <div
      class="side-box__inner"
      :class="{
        opened: opened.indexOf('removeService') >= 0,
        'last-active': opened.indexOf('removeService') == opened.length - 1,
      }"
    >
      <div
        class="side-box__header d-flex justify-content-between align-items-center"
      >
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="services.length > 0">
          {{ $filters.firstUpper($t("odebrat")) }}
          <span v-if="services.length > 1 && services.length < 5">
            {{ services.length }} {{ $t("sluzby") }}
          </span>
          <span v-else-if="services.length > 5">
            {{ services.length }} {{ $t("sluzbam") }}
          </span>
          <span v-else>
            {{ $t("sluzbu") }} {{ services[0].custServiceName }}
          </span>
          {{ $t("odProjektu") }}
        </h2>
      </div>
      <div v-if="projects" class="side-box__content">
        <div class="my-4">
          <FormSelectMultiple
            :items="projects"
            :label="$t('vyberteProjekt')"
            :placeholder="$t('SELECT_PROJECT_FROM_LIST')"
            :value="selectedProjects"
            class="mb-3"
            item-text="projectName"
            item-value="projectId"
            side-box
            @change="selectedProjects = $event"
          />
        </div>
      </div>
    </div>
    <save-confirmation-modal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @yes="runSave()"
      @no="closeBox('removeService')"
      @close="toggleConfirmation"
    />
    <div v-if="errorsToTranslate.length > 0">
      <error-modal
        :opened="openedError"
        :centered="true"
        :errors="errorsToTranslate"
        @close="
          () => {
            openedError = false
            $emit('closeBox', 'removeService')
          }
        "
      />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import { useAdminStore } from "@/store/modules/admin"
export default {
  components: {
    FormSelectMultiple,
    "save-confirmation-modal": SaveConfirmationModal,
    "error-modal": ErrorModal,
  },
  props: {
    services: Array,
    opened: Array,
  },
  setup() {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  data() {
    return {
      projects: [],
      selectedProjects: [],
      projectsOpened: false,
      selectProjectVisible: false,
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false,
    }
  },
  computed: {
    storedCustomer() {
      return this.adminStore.customer
    },
  },
  watch: {
    storedCustomer() {
      this.loadProjects()
    },
  },
  mounted() {
    if (this.storedCustomer) {
      this.loadProjects()
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "removeService") {
        this.$emit("closeBox", box)
      } else {
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    loadProjects() {
      console.log("loadProjects() - start")
      console.log("selectedServices")
      console.log(this.services)
      console.log("selectedCustomer")
      console.log(this.storedCustomer.customerId)
      this.projects = []
      /**
       * load all projects
       */
      axios
        .get(
          process.env.VUE_APP_API +
            "/customers/" +
            this.storedCustomer.customerId +
            "/projects?limit=1000&sort=projectName"
        )
        .then((resultProjects) => {
          /**
           * load projects for selected services
           */
          this.services.forEach((item) => {
            axios
              .get(
                process.env.VUE_APP_API +
                  "/services/" +
                  item.custServiceId +
                  "/projects?limit=1000"
              )
              .then((resultServicesProjects) => {
                resultServicesProjects.data.data.forEach((p) => {
                  if (
                    //this.projects.indexOf(p) == -1 &&
                    resultProjects.data.data.some(
                      (ap) => ap.projectId === p.projectId
                    )
                  ) {
                    if (
                      !this.projects.some((pp) => pp.projectId === p.projectId)
                    ) {
                      this.projects.push(p)
                    }
                  }
                })
                this.projects.sort(function (a, b) {
                  var nameA = a.projectName.toUpperCase() // převede jméno projektu na velká písmena pro správné řazení
                  var nameB = b.projectName.toUpperCase() // převede jméno projektu na velká písmena pro správné řazení
                  if (nameA < nameB) {
                    return -1
                  }
                  if (nameA > nameB) {
                    return 1
                  }
                  return 0 // návrat hodnoty 0, pokud jsou oba názvy projektů stejné
                })
              })
              .catch((error) => {
                this.errorsToTranslate.push(error.data)
              })
          })
        })
        .catch(() => {})
      console.log("loadProjects() - end")
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true
    },
    addRemoveProject(project) {
      if (this.selectedProjects.indexOf(project) == -1) {
        this.selectedProjects.push(project)
      } else {
        this.selectedProjects.splice(this.selectedProjects.indexOf(project), 1)
      }
      //
    },
    runEdit() {
      this.errorsToTranslate = []
      let promises = []
      this.services.forEach((item) => {
        this.selectedProjects.forEach((project) => {
          promises.push(
            axios
              .delete(
                process.env.VUE_APP_API +
                  "/services/" +
                  item.custServiceId +
                  "/projects/" +
                  project.projectId +
                  "/assign"
              )
              .then(/*result*/ () => {})
              .catch((error) => {
                let message = error.data.errors[0]
                error.data.errors = []
                error.data.errors.push({
                  message: message,
                  attribute: {
                    custServiceId: item.custServiceId,
                    custServiceName: item.custServiceName,
                  },
                })
                this.errorsToTranslate.push(error.data)
              })
          )
        })
      })
      Promise.all(promises).then(() => {
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
        } else {
          this.$store.commit("modals/setGlobalNotification", {
            text: "notificationProjectsDelete",
            error: false,
          })
          this.$emit("closeBox", "removeService")
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
